module.exports = __webpack_public_path__ + "static/media/noChat.658c792c.png";